<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>
<script>
  export default {
    name: "App",
    data() {
      return {
        isRouterAlive: true
      }
    },

    beforeRouteEnter(to, from, next) {
      if (from.path !== "/") {
        sessionStorage.removeItem("myCurrentPage");
      }
      next();
    },

    provide() {
      return {
        reload: this.reload
      }
    },

    methods: {
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      }
    },

    beforeDestroy() {
      localStorage.removeItem('temporaryId');
      window.onbeforeunload = function (e) {
        let Ele = e || window.event;
        let bool = ((event.clientX > document.body.clientWidth && event.clientY < 0) || event.altKey);
        if (bool) {
          Ele.returnValue = "关闭提示";
        }
      };
    }
  };
</script>
<style lang="less" scoped>
  @import "./assets/css/app.less";
</style>
